/**
 * Notas V2 em modo demo: notas editáveis por aluno (Prova 1 / Prova 2) em localStorage.
 */

import { DEMO_TURMA_DISC } from "./buildDemoOccurrences";

const STORAGE_KEY = "waybee-class-diary-demo-grades-v2";

export function demoGradesV2SessionKey(idTurmaDisc, period) {
  return `${String(idTurmaDisc)}|${String(period)}`;
}

function readRoot() {
  if (typeof localStorage === "undefined") {
    return {};
  }
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw);
    return typeof parsed === "object" && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
}

function writeRoot(root) {
  if (typeof localStorage === "undefined") {
    return;
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(root));
  } catch {
    // ignore
  }
}

export function loadDemoGradesV2Session(sessionKey) {
  const root = readRoot();
  const entry = root[sessionKey];
  if (!entry || typeof entry !== "object") {
    return null;
  }
  return entry;
}

/**
 * POST ClassDiaryV1/grades-v2/job — body: { filter, grades, classId }.
 */
export function applyDemoGradesV2JobSave(body) {
  if (!body || !body.filter || !body.filter.course) {
    return;
  }
  const { filter } = body;
  const { period } = filter;
  const { idTurmaDisc } = filter.course;
  if (
    idTurmaDisc == null ||
    period == null ||
    String(idTurmaDisc) !== String(DEMO_TURMA_DISC)
  ) {
    return;
  }

  const sessionKey = demoGradesV2SessionKey(idTurmaDisc, period);
  const existing = loadDemoGradesV2Session(sessionKey);
  const byRa = {};
  if (existing && existing.byRa) {
    Object.keys(existing.byRa).forEach(ra => {
      byRa[String(ra)] = { ...existing.byRa[ra] };
    });
  }

  const rows = body.grades;
  if (!Array.isArray(rows)) {
    return;
  }

  rows.forEach(row => {
    const ra = row.studentId == null ? null : String(row.studentId);
    if (!ra) {
      return;
    }
    const col = `${row.idStep || ""}-${row.idExam || ""}`;
    const empty =
      row.value === "" ||
      row.value === null ||
      row.value === undefined ||
      (typeof row.value === "string" && row.value.trim() === " ");

    if (!byRa[ra]) {
      byRa[ra] = {};
    }
    if (empty) {
      delete byRa[ra][col];
    } else {
      byRa[ra][col] = String(row.value).trim();
    }
    if (Object.keys(byRa[ra]).length === 0) {
      delete byRa[ra];
    }
  });

  const root = readRoot();
  root[sessionKey] = { byRa };
  writeRoot(root);
}
